import type { ReactNode } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import BrandTickActiveIcon from "../../../components/icons/BrandTickActiveIcon";
import BrandTickInactiveIcon from "../../../components/icons/BrandTickInactiveIcon";

export const CardSelectable = ({
	children,
	title,
	subtitle,
	onClick,
	activated = false,
	inline = false,
	w = "100%",
}: {
	children?: ReactNode;
	title?: string;
	subtitle?: string | ReactNode;
	onClick?: () => void;
	activated?: boolean;
	inline?: boolean;
	w?: string;
}) => {
	const style = activated
		? { border: "solid 2px", borderColor: "brand.700", bgColor: "brand.50" }
		: { border: "solid 1px", borderColor: "gray.200", bgColor: "white" };
	return (
		<Flex
			direction={inline ? "row" : "column"}
			justify={inline ? "space-between" : undefined}
			gap={2}
			w={w}
			p={4}
			borderRadius="md"
			{...style}
			onClick={onClick}
			cursor="pointer"
		>
			<Box className="w-full">
				<Flex justifyContent="space-between" alignItems="center">
					<Flex alignItems="center" gap={2}>
						{title !== undefined && (
							<Text
								lineHeight="27px"
								fontSize="18px"
								fontWeight="600"
								color="gray.700"
							>
								{title}
							</Text>
						)}
						{subtitle &&
							inline === true &&
							(typeof subtitle === "string" ? (
								<Text
									lineHeight="24px"
									fontSize="16px"
									fontWeight="400"
									color="gray.600"
								>
									{subtitle}
								</Text>
							) : (
								subtitle
							))}
					</Flex>
					{activated ? <BrandTickActiveIcon /> : <BrandTickInactiveIcon />}
				</Flex>
				{title === undefined && children}
				{subtitle &&
					inline === false &&
					(typeof subtitle === "string" ? (
						<Text
							lineHeight="24px"
							fontSize="16px"
							fontWeight="400"
							color="gray.600"
						>
							{subtitle}
						</Text>
					) : (
						subtitle
					))}
			</Box>
		</Flex>
	);
};
